module.exports = __webpack_public_path__ + "img/logo.bd775884.svg";